// AUTO-GENERATED by scripts/genBuildInfo.js — do not edit or commit.
// Regenerated on every `npm run build` / `npm start`.
export const BUILD_INFO = {
  version: "1.3.0",
  commit: "61828f2",
  date: "2026-09-20",
};
